<template>
    <div>
        <div v-if="carregando" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>
        <div v-else class="u-mt-20" style="padding: 20px 12px;">
            <h4><i class="el-icon-food"></i> Cardápio do dia</h4>
            <p style="color:#909399;">{{ dataHoje }}</p>

            <div v-if="temItens">
                <div v-for="(itens, refeicao) in refeicoes" :key="refeicao" class="bloco-refeicao">
                    <div class="titulo-refeicao">{{ formatarRefeicao(refeicao) }}</div>
                    <el-table :data="itens" stripe style="width: 100%;" empty-text="Nenhum item.">
                        <el-table-column label="Item" min-width="220">
                            <template slot-scope="scope">{{ scope.row.item || '-' }}</template>
                        </el-table-column>
                        <el-table-column label="Modalidade" min-width="140">
                            <template slot-scope="scope">{{ formatarModalidade(scope.row.modalidade) }}</template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>

            <el-alert
                v-else
                :title="aviso || 'Nenhum cardápio disponível para hoje.'"
                type="info"
                :closable="false"
                show-icon
                style="margin-top: 12px;"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Cardapio',
    data: () => ({
        carregando: false,
        refeicoes: {},
        aviso: ''
    }),
    computed: {
        dataHoje () {
            return this.$moment().format('DD/MM/YYYY')
        },
        temItens () {
            return this.refeicoes && Object.keys(this.refeicoes).length > 0
        }
    },
    mounted () {
        if (!localStorage.getItem('pa85726549Token')) {
            this.$router.push('/')
            return
        }
        this.carregar()
    },
    methods: {
        carregar () {
            this.carregando = true
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/portal/cardapio-do-dia`,
                {}, // instituição resolvida no backend pela turma do aluno (via token)
                this.$store.getters.getHeaderAuth
            ).then(response => {
                this.carregando = false
                const data = response.data || {}
                if (typeof data.erro !== 'undefined') {
                    window.eventBus.$emit('alert', { msg: data.erro, type: 'warning' })
                    return
                }
                this.refeicoes = data.refeicoes || {}
                this.aviso = data.aviso || ''
            }).catch(error => {
                this.carregando = false
                this.$store.commit('throwException', error)
            })
        },
        formatarRefeicao (r) {
            if (!r) return 'Outras'
            return String(r).charAt(0).toUpperCase() + String(r).slice(1)
        },
        formatarModalidade (m) {
            if (!m) return '-'
            return String(m).charAt(0).toUpperCase() + String(m).slice(1)
        }
    }
}
</script>

<style scoped>
.bloco-refeicao {
    margin-bottom: 18px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
}
.titulo-refeicao {
    background: #f5f7fa;
    padding: 10px 14px;
    font-weight: bold;
    color: #303133;
    border-bottom: 1px solid #ebeef5;
}
</style>
